import org.w3c.dom.events.Event

typealias Callback = (Event) -> Unit

fun String.normalize() : String = this.replace("_", " ")
    .lowercase()
    .replaceFirstChar { if (it.isLowerCase()) it.titlecase() else it.toString() }

